import {
    Button,
    Form,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@/platform/ui';
import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useForm, usePage } from '@inertiajs/react';
import { useState } from 'react';

const FIELDS = [
    { key: 'email', label: 'Email', type: 'email' },
    { key: 'phone_number', label: 'Telefoonnummer', type: 'tel' },
    { key: 'phone_number_work', label: 'Telefoonnummer werk', type: 'tel' },
    { key: 'mobile_number', label: 'Mobiel nummer', type: 'tel' },
    { key: 'mobile_number_work', label: 'Mobiel nummer werk', type: 'tel' },
];

const CommunicationUpdateForm = () => {
    const [isEditing, setIsEditing] = useState(false);

    const { employee } = usePage().props;

    const latestCommunication = employee?.communications?.reduce(
        (latest, communication) =>
            !latest || communication.id > latest.id ? communication : latest,
        null
    );

    const { data, setData, patch, errors, processing, resetAndClearErrors } =
        useForm(
            Object.fromEntries(
                FIELDS.map(({ key }) => [key, latestCommunication?.[key] || ''])
            )
        );

    const toggleEditing = () => {
        if (!isEditing) {
            setIsEditing(true);

            return;
        }

        resetAndClearErrors();
        setIsEditing(false);
    };

    const handleSubmit = () => {
        patch(
            `/customers/${employee.customer_id}/employees/${employee.id}/communications/${latestCommunication.id}`,
            {
                reset: ['employee', 'communicable_subjects', 'navigation'],
                onSuccess: () => setIsEditing(false),
            }
        );
    };

    return (
        <Segment>
            <SegmentHeader header='Communicatie'>
                <Button type='button' onClick={toggleEditing}>
                    {isEditing ? (
                        <XMarkIcon className='size-4' />
                    ) : (
                        <PencilIcon className='size-4' />
                    )}
                </Button>
            </SegmentHeader>
            <SegmentContent>
                <Form onSubmit={handleSubmit}>
                    <Table striped>
                        <TableBody>
                            {FIELDS.map(({ key, label, type }) => (
                                <TableRow key={key}>
                                    <TableCell className='font-bold'>
                                        {label}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {isEditing ? (
                                            <Input
                                                type={type}
                                                value={data?.[key] || ''}
                                                onChange={event =>
                                                    setData(
                                                        key,
                                                        event.target.value
                                                    )
                                                }
                                                error={errors?.[key]}
                                            />
                                        ) : (
                                            latestCommunication?.[key] || '-'
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    {isEditing && (
                        <div className='mt-4 flex items-center justify-end'>
                            <Button
                                type='submit'
                                variant='primary'
                                loading={processing}
                            >
                                Opslaan
                            </Button>
                        </div>
                    )}
                </Form>
            </SegmentContent>
        </Segment>
    );
};

export default CommunicationUpdateForm;
